import styled from 'styled-components';
import { colors } from '@commonsku/styles';

type IconCircleProps = {
    $width?: number;
    $height?: number;
    $backgroundColor?: string;
    $borderColor?: string;
};

export const IconCircle = styled.div<IconCircleProps>`
    width: ${({ $width }) => $width ?? 56}px;
    height: ${({ $height }) => $height ?? 56}px;
    border-radius: 50%;
    background-color: ${({ $backgroundColor }) => $backgroundColor ?? colors.neutrals[20]};
    border: ${({ $borderColor }) => $borderColor ? `1px solid ${$borderColor}` : 'none'};
    display: flex;
    align-items: center;
    justify-content: center;
`;
